import {Inspectable, Dependencies} from './types';

import {toLocalString} from 'shared/utils/dateTime';
import {identity} from 'shared/utils/identity';

export const properties = ['dateTime', 'startDate', 'finishDate'] as const;
type ConvertableProperty = (typeof properties)[number];
type ConvertableEntity = Values<CoreState> | RecordEntry;

export function inspectableObject<
  TEntity extends ConvertableEntity,
  TFields extends keyof TEntity,
  TReturn extends Inspectable<TEntity, Intersection<TFields, ConvertableProperty>>,
>(entity: TEntity, di: Dependencies = {}): TReturn {
  const {converter = toLocalString} = di;

  return Object.entries(entity).reduce((result, entry) => {
    const [key, value] = entry;
    const shouldConvert = properties.includes(key as ConvertableProperty);
    const transform = shouldConvert ? converter : identity;
    return {...result, [key]: transform(value)};
  }, {}) as TReturn;
}
